import { useMemo } from 'preact/hooks'

export interface DeviceInfo {
  isMobile: boolean
  isWebView: boolean
  isAndroid: boolean
  isIOS: boolean
  shouldUseMobileFlow: boolean
  userAgent: string
}

export function useDeviceDetection(): DeviceInfo {
  return useMemo(() => {
    const userAgent = navigator.userAgent

    const isMobile =
      /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)

    const isWebView = (() => {
      const ua = userAgent.toLowerCase()
      return (
        ua.includes('wv') ||
        ua.includes('webview') ||
        // Dodatkowe wykrywanie WebView
        (ua.includes('android') && !ua.includes('chrome')) ||
        ua.includes('fbav') || // Facebook WebView
        ua.includes('instagram')
      ) // Instagram WebView
    })()

    const isAndroid = /Android/i.test(userAgent)
    const isIOS = /iPhone|iPad|iPod/i.test(userAgent)

    const shouldUseMobileFlow = isMobile || isWebView

    return {
      isMobile,
      isWebView,
      isAndroid,
      isIOS,
      shouldUseMobileFlow,
      userAgent,
    }
  }, [])
}
